<style lang="less">
    .timer p{
        width: 100%;
        height: 11vh;
        line-height: 11vh;
        text-align: center;
        font-size: .5rem;
        font-weight: bold;
        letter-spacing: .02rem;
    }
</style>
<template>
    <div class="timer">
        <p>{{times}}</p>
    </div>
</template>
<script>
export default {
    props:{
        time:{
            type:Number,
            default:0,
        },
        pause:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return {
            times:'00:00',
            timer:0,
            interval:null,
        }
    },
    watch:{
        pause(old){
            this.updatePause(old);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        getTime(){
            return this.timer;
        },
        init(){
            this.timer = this.time;
            let vm = this;
            vm.times = vm.updateTime(this.timer);
            console.log(this.timer);
            this.interval = setInterval(()=>{
                this.timer -= 1;
                vm.times = vm.updateTime(this.timer);
                if(this.timer <= 0){
                    clearInterval(this.interval);
                    this.interval = null;
                }
            },1000);
        },
        updatePause(old){
            console.log(old);
            if(old){
                this.interval && clearInterval(this.interval);
                this.interval = null;
                this.$emit('change',this.timer);
            }else{
                this.init();
            }
        },
        updateTime(time){
            if(time == 0){
                return '00:00';
            }
            time = parseInt(time);
            let s = time%60;
            let m = Math.floor(time/60);
            s= s>9?s:('0'+s);
            m= m>9?m:('0'+m);
            return m+':'+s;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/timer.vue